import React from "react";

/* eslint-disable react/jsx-props-no-spreading */

const MediaContext = React.createContext([]);

const defaultMediaState = {
  players: {},
};

function mediaReducer(state, action) {
  const { type, playerId, playerFunctions } = action;
  switch (type) {
    case "PLAYER_REGISTER": {
      const { players } = state;
      players[playerId] = playerFunctions || {};
      return { ...state, players };
    }

    case "PLAYER_UNREGISTER": {
      const { players } = state;
      delete players[playerId];
      return { ...state, players };
    }

    case "PLAYER_PLAY": {
      const { players } = state;
      Object.keys(players).forEach((currentPlayerId) => {
        if (
          currentPlayerId !== playerId &&
          typeof players[currentPlayerId].stop === 'function'
        ) {
          players[currentPlayerId].stop();
        }
      });
      return state;
    }

    case "PLAYER_STOP": {
      // Object.keys(players).forEach((currentPlayerId) => {
      //   if (
      //     currentPlayerId !== playerId &&
      //     typeof players[currentPlayerId].resume === 'function'
      //   ) {
      //     players[currentPlayerId].resume();
      //   }
      // });
      return state;
    }

    default: {
      throw new Error(`Unsupported action type: ${type}`);
    }
  }
}

export const useMediaContext = () => {
  const context = React.useContext(MediaContext);

  if (!context) {
    throw new Error(`useMediaContext must be used within MediaContext`);
  }

  const [state, dispatch] = context;
  return { state, dispatch };
};

export const MediaContextProvider = props => {
  const [state, dispatch] = React.useReducer(mediaReducer, defaultMediaState);
  const value = React.useMemo(() => [state, dispatch], [state]);
  return <MediaContext.Provider value={value} {...props} />;
};
